import tree from './tree.js'
export default { tree }
